import React from 'react';
import { isCatalogPriceExpired } from '../quoteCatalogModel';

const numeric = (value) => Number(value || 0);

const effectivePrice = (item) => (
  item.purchasePriceMode === 'forced'
    ? numeric(item.forcedUnitPurchasePrice)
    : numeric(item.catalogUnitPurchasePrice ?? item.unitPurchasePrice)
);

const effectiveDiscount = (item) => (
  item.discountMode === 'forced'
    ? numeric(item.forcedDiscountRate)
    : numeric(item.discountRate)
);

const netPrice = (item) => effectivePrice(item) * (1 - Math.min(100, Math.max(0, effectiveDiscount(item))) / 100);

export default function QuoteMaterialItemsEditor({ items = [], disabled, formatMoney, onChange }) {
  const replace = (index, patch) => onChange(items.map((item, itemIndex) => (
    itemIndex === index ? { ...item, ...patch } : item
  )));

  const remove = (index) => onChange(items.filter((_, itemIndex) => itemIndex !== index));

  if (!items.length) return <p className="quote-detail-empty">Aucun composant matériel détaillé.</p>;

  return (
    <div className="quote-material-items">
      {items.map((item, index) => {
        const expired = isCatalogPriceExpired(item);
        return (
          <article className="quote-material-item" key={item.id || `${item.referenceSnapshot}-${index}`}>
            <header>
              <div>
                <strong>{item.descriptionSnapshot || item.referenceSnapshot || `Matériel ${index + 1}`}</strong>
                <small>{[item.manufacturerNameSnapshot, item.referenceSnapshot, item.supplierNameSnapshot].filter(Boolean).join(' · ') || 'Saisie manuelle'}</small>
              </div>
              <div className="quote-material-item__badges">
                {item.catalogProductId && <span>Catalogue</span>}
                {item.purchasePriceMode === 'forced' && <span>Prix forcé</span>}
                {item.discountMode === 'partner' && <span>Remise partenaire</span>}
                {item.discountMode === 'forced' && <span>Remise forcée</span>}
                {expired && <span className="warning">Tarif expiré</span>}
              </div>
            </header>
            <div className="quote-material-item__grid">
              <label><span>Quantité composant</span><input type="number" min="0" step="0.01" disabled={disabled} value={item.quantity ?? 1} onChange={(event) => replace(index, { quantity: event.target.value })} /></label>
              <label><span>Prix achat brut unitaire</span><input type="number" min="0" step="0.01" disabled={disabled} value={effectivePrice(item)} onChange={(event) => replace(index, { purchasePriceMode: 'forced', forcedUnitPurchasePrice: event.target.value })} /></label>
              <label><span>Remise achat (%)</span><input type="number" min="0" max="100" step="0.01" disabled={disabled} value={effectiveDiscount(item)} onChange={(event) => replace(index, { discountMode: 'forced', forcedDiscountRate: event.target.value })} /></label>
              <div><span>Prix net unitaire</span><strong>{formatMoney(netPrice(item))}</strong></div>
            </div>
            <footer>
              {item.datasheetUrlSnapshot && <a href={item.datasheetUrlSnapshot} target="_blank" rel="noreferrer">Fiche technique capturée</a>}
              <button className="basic-button quote-line-remove" type="button" disabled={disabled} onClick={() => remove(index)}>Retirer le composant</button>
            </footer>
          </article>
        );
      })}
    </div>
  );
}
